import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Drawer.module.scss'

const DrawerAvatar = ({ src, alt = '', icon }) => (
  src ? (
    <img src={src} alt={alt} className={classNames(classes.avatar, 'flex-shrink-0')} />
  ) : (
    <span className={classNames(classes.avatar, classes.avatarIcon, 'd-inline-flex align-items-center justify-content-center flex-shrink-0')}>
      <i className={classNames('fa', icon)} aria-hidden='true' />
    </span>
  )
)

DrawerAvatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  icon: PropTypes.string,
}

export default DrawerAvatar
